// extracted by mini-css-extract-plugin
export default {"cardWrrapper":"DashboardCard_cardWrrapper__W++ov"};